import s from '../allservices.jsx'
import { getClientId, getClientSecret, buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
export const verifyCardService = (actionCallback) => {
    //     let token = "Token " + localStorage.getItem('token')
    const isDigitalCard = localStorage.getItem('isDigitalCard') === 'true';
    if (isDigitalCard) {
        // Digital cards don't go through verify_card_number
        return;
    }
    let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
    const cardNumber = localStorage.getItem('cardNumber')
    const digitalCard = localStorage.getItem('eCard')
    if (cardNumber === null && digitalCard === null) {
        actionCallback("No card reference found.", "Failure")
        return;
    }
    const state = {
        cardNumber: digitalCard,
        applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
          KitNo:localStorage.getItem('kitNumber')
        // cardProxyNo: localStorage.getItem('eCardRef'),
        // cvv: localStorage.getItem('eCvv'),
        // cardExpiry: localStorage.getItem('eCardExpiry'),
    }
    let gvvid = getClientId();
    let traceId = getClientId();
    fetch(plink + s.verify_card_number, {
        // fetch(plink + s.verifyDigitalCard,{
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'clientId': gvvid,
            'clientSecret': getClientSecret(gvvid, localStorage.getItem('acno')),
            // 'clientSecret': getClientSecret(gvvid, localStorage.getItem('KitNumber')),


            'X-Trace-Id': traceId,
            'X-Client-APP': buildClientHeader(),
            //   'Authorization': token
        },
        body: JSON.stringify(state)
    })
        .then(response => {
            if (response.status === 200) {
                localStorage.setItem("isDigitalCard", "false")

                response.json().then(json => actionCallback(json, "success"))
            }
            else if (response.status === 401) {
                let data = "signout."
                actionCallback(data, "sessionout")
            }
            else {
                let data = "No Data."
                actionCallback(data, "emptyBody")
            }

        })
        .catch(() => {
            actionCallback("Network error.", "Failure")
        })
}


// WEBPACK FOOTER //
// ./src/services/components/verify_card.jsx